<div class="d-flex">
    <a class="btn btn-sm" (click)="emitUndo()" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Undo">
        <i class="fa-solid fa-share fa-flip-horizontal" [style.opacity]="canUndo ? 1 : 0.4"></i>
    </a>

    <a class="btn btn-sm" (click)="emitRedo()" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Redo">
        <i class="fa-solid fa-share" [style.opacity]="canRedo ? 1 : 0.4"></i>
    </a>
</div>